var map = {
	"./Paper_clip_font_awesome.svg": "./src/components/SvgIcon/Paper_clip_font_awesome.svg",
	"./add_user.svg": "./src/components/SvgIcon/add_user.svg",
	"./alert_circle.svg": "./src/components/SvgIcon/alert_circle.svg",
	"./alert_triagle.svg": "./src/components/SvgIcon/alert_triagle.svg",
	"./archive.svg": "./src/components/SvgIcon/archive.svg",
	"./arrow-down.svg": "./src/components/SvgIcon/arrow-down.svg",
	"./arrow-left.svg": "./src/components/SvgIcon/arrow-left.svg",
	"./arrow-right.svg": "./src/components/SvgIcon/arrow-right.svg",
	"./arrow-up.svg": "./src/components/SvgIcon/arrow-up.svg",
	"./asterisk.svg": "./src/components/SvgIcon/asterisk.svg",
	"./behance.svg": "./src/components/SvgIcon/behance.svg",
	"./bell-o.svg": "./src/components/SvgIcon/bell-o.svg",
	"./book.svg": "./src/components/SvgIcon/book.svg",
	"./bubble.svg": "./src/components/SvgIcon/bubble.svg",
	"./calendar.svg": "./src/components/SvgIcon/calendar.svg",
	"./camcorder.svg": "./src/components/SvgIcon/camcorder.svg",
	"./camera.svg": "./src/components/SvgIcon/camera.svg",
	"./chevron-down.svg": "./src/components/SvgIcon/chevron-down.svg",
	"./chevron-left.svg": "./src/components/SvgIcon/chevron-left.svg",
	"./chevron-right.svg": "./src/components/SvgIcon/chevron-right.svg",
	"./chevron-up.svg": "./src/components/SvgIcon/chevron-up.svg",
	"./clock.svg": "./src/components/SvgIcon/clock.svg",
	"./close.svg": "./src/components/SvgIcon/close.svg",
	"./collection.svg": "./src/components/SvgIcon/collection.svg",
	"./credit-card.svg": "./src/components/SvgIcon/credit-card.svg",
	"./cross_border.svg": "./src/components/SvgIcon/cross_border.svg",
	"./cross_circle.svg": "./src/components/SvgIcon/cross_circle.svg",
	"./dislike.svg": "./src/components/SvgIcon/dislike.svg",
	"./dollar.svg": "./src/components/SvgIcon/dollar.svg",
	"./dots-three-horizontal.svg": "./src/components/SvgIcon/dots-three-horizontal.svg",
	"./email.svg": "./src/components/SvgIcon/email.svg",
	"./exclamation.svg": "./src/components/SvgIcon/exclamation.svg",
	"./eye-slash.svg": "./src/components/SvgIcon/eye-slash.svg",
	"./facebook.svg": "./src/components/SvgIcon/facebook.svg",
	"./film.svg": "./src/components/SvgIcon/film.svg",
	"./filter_list.svg": "./src/components/SvgIcon/filter_list.svg",
	"./flag.svg": "./src/components/SvgIcon/flag.svg",
	"./floppy-o.svg": "./src/components/SvgIcon/floppy-o.svg",
	"./google-icon.svg": "./src/components/SvgIcon/google-icon.svg",
	"./google-plus.svg": "./src/components/SvgIcon/google-plus.svg",
	"./group.svg": "./src/components/SvgIcon/group.svg",
	"./heart-outline.svg": "./src/components/SvgIcon/heart-outline.svg",
	"./heart.svg": "./src/components/SvgIcon/heart.svg",
	"./help.svg": "./src/components/SvgIcon/help.svg",
	"./icon_ok.svg": "./src/components/SvgIcon/icon_ok.svg",
	"./image.svg": "./src/components/SvgIcon/image.svg",
	"./inbox.svg": "./src/components/SvgIcon/inbox.svg",
	"./info_line.svg": "./src/components/SvgIcon/info_line.svg",
	"./info_line_white.svg": "./src/components/SvgIcon/info_line_white.svg",
	"./information_circle.svg": "./src/components/SvgIcon/information_circle.svg",
	"./instagram.svg": "./src/components/SvgIcon/instagram.svg",
	"./like.svg": "./src/components/SvgIcon/like.svg",
	"./location_pin.svg": "./src/components/SvgIcon/location_pin.svg",
	"./logo.svg": "./src/components/SvgIcon/logo.svg",
	"./mail-forward.svg": "./src/components/SvgIcon/mail-forward.svg",
	"./map_marker.svg": "./src/components/SvgIcon/map_marker.svg",
	"./menu.svg": "./src/components/SvgIcon/menu.svg",
	"./minus_circle.svg": "./src/components/SvgIcon/minus_circle.svg",
	"./money.svg": "./src/components/SvgIcon/money.svg",
	"./more.svg": "./src/components/SvgIcon/more.svg",
	"./music.svg": "./src/components/SvgIcon/music.svg",
	"./office.svg": "./src/components/SvgIcon/office.svg",
	"./padlock.svg": "./src/components/SvgIcon/padlock.svg",
	"./paper.svg": "./src/components/SvgIcon/paper.svg",
	"./pause.svg": "./src/components/SvgIcon/pause.svg",
	"./paypal.svg": "./src/components/SvgIcon/paypal.svg",
	"./pencil.svg": "./src/components/SvgIcon/pencil.svg",
	"./planet_earth.svg": "./src/components/SvgIcon/planet_earth.svg",
	"./play.svg": "./src/components/SvgIcon/play.svg",
	"./play_circle.svg": "./src/components/SvgIcon/play_circle.svg",
	"./plus.svg": "./src/components/SvgIcon/plus.svg",
	"./plus_circle.svg": "./src/components/SvgIcon/plus_circle.svg",
	"./search.svg": "./src/components/SvgIcon/search.svg",
	"./settings.svg": "./src/components/SvgIcon/settings.svg",
	"./share_social.svg": "./src/components/SvgIcon/share_social.svg",
	"./soundcloud.svg": "./src/components/SvgIcon/soundcloud.svg",
	"./sparkles.svg": "./src/components/SvgIcon/sparkles.svg",
	"./sphere.svg": "./src/components/SvgIcon/sphere.svg",
	"./star.svg": "./src/components/SvgIcon/star.svg",
	"./stop.svg": "./src/components/SvgIcon/stop.svg",
	"./thumb-down.svg": "./src/components/SvgIcon/thumb-down.svg",
	"./thumb-up.svg": "./src/components/SvgIcon/thumb-up.svg",
	"./tick.svg": "./src/components/SvgIcon/tick.svg",
	"./tick_border.svg": "./src/components/SvgIcon/tick_border.svg",
	"./tick_circle.svg": "./src/components/SvgIcon/tick_circle.svg",
	"./tick_outline.svg": "./src/components/SvgIcon/tick_outline.svg",
	"./timeular.svg": "./src/components/SvgIcon/timeular.svg",
	"./timeular_full.svg": "./src/components/SvgIcon/timeular_full.svg",
	"./trash.svg": "./src/components/SvgIcon/trash.svg",
	"./twitter.svg": "./src/components/SvgIcon/twitter.svg",
	"./unlock.svg": "./src/components/SvgIcon/unlock.svg",
	"./upload.svg": "./src/components/SvgIcon/upload.svg",
	"./user.svg": "./src/components/SvgIcon/user.svg",
	"./vimeo.svg": "./src/components/SvgIcon/vimeo.svg",
	"./world_globe.svg": "./src/components/SvgIcon/world_globe.svg",
	"./x.svg": "./src/components/SvgIcon/x.svg",
	"./youtube-play.svg": "./src/components/SvgIcon/youtube-play.svg",
	"./zoom.svg": "./src/components/SvgIcon/zoom.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/SvgIcon sync recursive ^\\.\\/.*\\.svg$";